export const GET_BNB_REQUEST = 'GET_BNB_REQUEST';
export const GET_BNB_DATA = 'GET_BNB_DATA';
export const GET_BNB_ERROR = 'GET_BNB_ERROR';